export default __webpack_public_path__ + "static/media/delete.8c94b954.svg";